export interface GeminiVoice {
  id: string;
  name: string;
}

export const GEMINI_VOICES: GeminiVoice[] = [
  { id: 'Aoede', name: 'Lily' },
  { id: 'Kore', name: 'Noah' },
  { id: 'Leda', name: 'Ava' },
  { id: 'Charon', name: 'Max' },
  { id: 'Fenrir', name: 'Finn' },
  { id: 'Orus', name: 'Leo' },
  { id: 'Puck', name: 'Sam' },
  { id: 'Zephyr', name: 'Mia' },
];

export const DEFAULT_VOICE_ID = 'Aoede';

export interface TutorPersonality {
  id: string;
  name: string;
  emoji: string;
  /** Replaces the IDENTITY section in the system prompt */
  identity: string;
  /** Replaces the SPEAKING STYLE section in the system prompt */
  speakingStyle: string;
}

export interface TutorCharacter {
  /** Matches backend personality id */
  personalityId: string;
  /** Gemini voice id */
  voiceId: string;
  name: string;
  emoji: string;
  /** CDN asset path, e.g. 'tutor/tutor-lily.png' */
  avatar: string;
}

export const TUTOR_CHARACTERS: TutorCharacter[] = [
  {
    personalityId: 'ada',
    voiceId: 'Aoede',
    name: 'Lily',
    emoji: '👩‍🏫',
    avatar: '/assets/tutor-series-v5/tutor-ada-series-v5.png',
  },
  { personalityId: 'wizard',             voiceId: 'Orus',   name: 'Leo',    emoji: '🪄',  avatar: '/assets/tutor-series-v5/tutor-wizard-series-v5.png' },
  { personalityId: 'pirate',             voiceId: 'Fenrir', name: 'Finn',   emoji: '🏴‍☠️', avatar: '/assets/tutor-series-v5/tutor-pirate-series-v5.png' },
  { personalityId: 'sports-commentator', voiceId: 'Charon', name: 'Max',    emoji: '🏟',  avatar: '/assets/tutor-series-v5/tutor-sports-commentator-series-v5.png' },
  { personalityId: 'detective',          voiceId: 'Puck',   name: 'Sam',    emoji: '🕵️', avatar: '/assets/tutor-series-v5/tutor-detective-series-v5.png' },
  { personalityId: 'mad-scientist',      voiceId: 'Leda',   name: 'Ava',    emoji: '🧪',  avatar: '/assets/tutor-series-v6/tutor-mad-scientist-female-series-v6.jpg' },
  { personalityId: 'anime-sensei',       voiceId: 'Zephyr', name: 'Mia',    emoji: '⛩️', avatar: '/assets/tutor-series-v5/tutor-anime-sensei-series-v5.png' },
  { personalityId: 'comedian',           voiceId: 'Kore',   name: 'Noah',   emoji: '🎤',  avatar: '/assets/tutor-series-v6/tutor-comedian-female-series-v6.jpg' },
];

export const DEFAULT_CHARACTER_ID = 'ada';
